import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: String, default: "dm" } }

  connect() {
    this.showPanel(this.activeValue)
  }

  switch(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.chatRailTab
    this.activeValue = tab
    this.showPanel(tab)
  }

  showPanel(name) {
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.chatRailTab === name
      tab.classList.toggle("bg-white", isActive)
      tab.classList.toggle("shadow-sm", isActive)
      tab.classList.toggle("text-slate-800", isActive)
      tab.classList.toggle("text-slate-500", !isActive)
    })

    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.chatRailPanel === name
      panel.classList.toggle("hidden", !isActive)
      panel.classList.toggle("flex", isActive)
    })
  }
}
